package com.appsyde.shared.modules.team.domain.usecase

import com.appsyde.shared.modules.team.domain.model.CreateInviteResult
import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class CreateInviteUseCase(
    private val repository: TeamRepository
) {
    suspend operator fun invoke(email: String): CreateInviteResult =
        repository.createInvite(email)
}
